export default "__VITE_ASSET__CPOhIyPS__"